module.exports = __webpack_public_path__ + "static/img/46.23e00321.png";